<template>
</template>

<script>
    export default {
        props: [
            'success',
            'warning',
            't',
        ],
        data(){ return {
            message: '',
            type: 'success',
            toast: null,
        }},
        mounted() {
            this.$root.$on('flash', this.displayFlashMessage)
            
            if (this.success) {
                this.displayFlashMessage(this.success, 'success')
            } else if (this.warning) {
                this.displayFlashMessage(this.warning, 'warning')
            }
        },
        methods: {
            displayFlashMessage(message, type = 'success') {
                if (this.toast) {
                    iziToast.hide({}, this.toast)
                    this.toast = null
                }

                if (type === 'success') {
                    iziToast.success({
                        title: 'OK',
                        message: message,
                        position: 'bottomLeft',
                    })
                } else if (type === 'warning') {
                    iziToast.warning({
                        title: this.t.warning,
                        message: message,
                        position: 'bottomLeft',
                    })
                } else if (type === 'spin') {
                    iziToast.info({
                        class: 'spinner-toast',
                        icon: 'fas fa-circle-notch fa-spin',
                        timeout: 100000,
                        progressBar: false,
                        title: this.t.loading,
                        message: '',
                        position: 'bottomLeft',
                        animateInside: false,
                    })

                    this.toast = document.querySelector('.spinner-toast')
                }
            },
        },
    }
</script>
